import React, {useEffect, useState} from 'react';
import {Form, Input, Select, Button, message, Flex, InputNumber} from 'antd';

export default ({id, value, onChange, accId, defaultValue, goodsId}) => {
    // if(!!defaultValue)
    const [levelList, setLevelList] = useState([]);

    useEffect(() => {
        getLevelList().then(list => {
            setLevelList(list.map(item => ({...item, goodsId})));
        });
    }, []);

    useEffect(() => {

        if (defaultValue instanceof Array && defaultValue.length) {
            const newLevelList =levelList.map(l => {

                const levelId = l.id;
                const centItem = defaultValue.find(item => item.levelId === levelId);

                if(centItem) {
                    return {
                        ...l,
                        percent: centItem.percent,
                    };
                }
                return l;
            });

            setLevelList(newLevelList);
        }
    }, [defaultValue]);

    const onPercentChange = (percent, id) => {
        console.log(percent, id);
        // let percent = e.target.value;

        const newLevelList = levelList.map(item => {
            if (item.id === id) {
                return {
                    ...item,
                    percent: percent,
                }
            } else {
                return item;
            }
        });

        setLevelList(newLevelList);
        onChange?.(newLevelList);
    };

    const getLevelList = async () => {
        let response = await fetch(`/api/shop/level-user/list?accId=${accId}`);
        let result = await response.json();

        if(result && result.success) {
            return result.data;
        }
        return [];
    }

    return (
        <div id={id}>
            {
                levelList.map(item => {
                    return <Flex direction="column" key={item.id} gap={10}>
                        <Flex justify="start" align="center" gap={10} style={{marginBottom: 10}}>
                            <div>{item.title}</div>
                            <div><InputNumber addonAfter='%' value={item.percent} step={0.1} max={99.99} min={0} onChange={(e) => onPercentChange(e, item.id)} /></div>
                        </Flex>
                    </Flex>
                })
            }
            <div><a href='/salesnet'>设置分销商/等级</a></div>
        </div>
    )
}